<mat-card>
    <mat-card-content>
        <h4>Please enter your address</h4>
        <address-auto-complete (setAddress)="getAddress($event)" addressType={{addressType}}>
        </address-auto-complete>
    </mat-card-content>
</mat-card>

<mat-card>
    <mat-card-content>
        <h4>Selected Address</h4>
        <form (ngSubmit)="onButtonClick()" fxLayout="column">
            <mat-form-field class="full-width" appearance="fill" *ngIf="isEstablishment()">
                <mat-label>Name:</mat-label>
                <input matInput placeholder="Name" [ngModel]="address.name" name="name" readonly>
            </mat-form-field>
            <mat-form-field class="full-width" appearance="fill">
                <mat-label>Address Line 1:</mat-label>
                <input matInput placeholder="Address Line 1" [ngModel]="address.addressLine1" name="addressLine1"
                    readonly>
            </mat-form-field>
            <mat-form-field class="full-width" appearance="fill">
                <mat-label>Suburb:</mat-label>
                <input matInput placeholder="Suburb" [ngModel]="address.suburb" name="suburb" readonly>
            </mat-form-field>
            <mat-form-field class="full-width" appearance="fill">
                <mat-label>State:</mat-label>
                <input matInput placeholder="State" [ngModel]="address.state" name="state" readonly>
            </mat-form-field>
            <mat-form-field class="full-width" appearance="fill">
                <mat-label>Post Code:</mat-label>
                <input matInput placeholder="PostCode" [ngModel]="address.postCode" name="postCode" readonly>
            </mat-form-field>
            <mat-form-field class="full-width" appearance="fill">
                <mat-label>Country:</mat-label>
                <input matInput placeholder="Country" [ngModel]="address.country" name="country" readonly>
            </mat-form-field>

            <hr />
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
                <button color="accent" type="submit" mat-flat-button
                    [disabled]="!this.address.addressLine1">Save</button>
            </div>
        </form>
    </mat-card-content>
</mat-card>
